module.exports = __webpack_public_path__ + "media/images/selfpromo__sidebar--image-4f8ca9eeb547c660b22a463ed5268d50.jpg";